import RankingBar from '@/components/NutrientRankingBar';
import NutrientRanking from '@/components/NutrientRanking';
import clsx from 'clsx';

type Props = {
  name: string;
  ranking: number | undefined;
  unit?: string;
  quantity?: number;
  nameSize: 'large' | 'base';
};

export default function Nutrient({
  name,
  quantity,
  unit,
  ranking,
  nameSize,
}: Props) {
  const notAvailable = !quantity && !ranking;

  return (
    <div
      className={`flex w-full items-center border-b border-gray-100 pt-2 pb-3 dark:border-gray-800 ${
        notAvailable ? 'opacity-50' : ''
      }`}
    >
      <div className="mr-2 flex w-full flex-col">
        <div className="flex items-center justify-between">
          <h3
            className={clsx(
              'truncate font-semibold capitalize leading-7',
              nameSize === 'large' ? 'text-lg' : 'text-base'
            )}
          >
            {name}
          </h3>

          {notAvailable ? (
            <> </>
          ) : (
            <div className="flex items-center">
              {quantity && (
                <div className="mr-1 text-sm text-gray-500">
                  <span className="mr-1 font-semibold">
                    {quantity >= 10
                      ? quantity.toFixed(0)
                      : quantity >= 1
                      ? quantity.toFixed(1)
                      : quantity?.toFixed(2)}
                  </span>
                  <span className="text-sm font-semibold">{unit}</span>
                </div>
              )}
            </div>
          )}
        </div>

        <RankingBar className={'mt-0'} value={ranking} />
      </div>
      <NutrientRanking value={ranking!} size={'sm'} className="mr-0" />
    </div>
  );
}
